export const CANADA_STATES = [
    'British Columbia',
    'GST/HST',
    'Manitoba',
    'Quebec',
    'Saskatchewan'
];
export const CANADA_DEFAULT_TAX = { name: 'GST/HST', state_code: 'GST/HST' };
